/**
 * constants.js
 * Definizioni delle costanti dell'applicazione
 */

// Ruoli utente
export const USER_ROLES = {
  MEMBER: 'member',
  ATHLETE: 'athlete',
  TECH: 'tech',
  MANAGER: 'manager',
  ADMIN: 'admin',
  PARENT: 'parent'
};

// Etichette dei ruoli utente predefiniti di sistema
export const SYSTEM_ROLE_LABELS = {
  [USER_ROLES.MEMBER]: 'Socio',
  [USER_ROLES.ATHLETE]: 'Atleta',
  [USER_ROLES.TECH]: 'Tecnico',
  [USER_ROLES.MANAGER]: 'Dirigente',
  [USER_ROLES.ADMIN]: 'Amministratore',
  [USER_ROLES.PARENT]: 'Genitore'
};

// Tipi di certificati medici
export const CERTIFICATE_TYPES = {
  COMPETITIVE: 'competitive',
  NON_COMPETITIVE: 'non_competitive'
};

// Etichette dei tipi di certificato
export const CERTIFICATE_TYPE_LABELS = {
  [CERTIFICATE_TYPES.NON_COMPETITIVE]: 'Non agonistico/Libretto Verde',
  [CERTIFICATE_TYPES.COMPETITIVE]: 'Agonistico'
};

// Stati dei certificati
export const CERTIFICATE_STATUS = {
  VALID: 'valid',
  EXPIRED: 'expired',
  EXPIRING: 'expiring'
};

// Etichette degli stati certificati
export const CERTIFICATE_STATUS_LABELS = {
  [CERTIFICATE_STATUS.VALID]: 'Valido',
  [CERTIFICATE_STATUS.EXPIRED]: 'Scaduto', 
  [CERTIFICATE_STATUS.EXPIRING]: 'In scadenza'
};

// Colori per i badge dei ruoli
export const ROLE_BADGE_COLORS = {
  [USER_ROLES.MEMBER]: 'secondary',
  [USER_ROLES.ATHLETE]: 'success',
  [USER_ROLES.TECH]: 'info',
  [USER_ROLES.MANAGER]: 'primary',
  [USER_ROLES.ADMIN]: 'danger',
  [USER_ROLES.PARENT]: 'dark'
};

// Colori per i badge degli stati certificati
export const CERTIFICATE_STATUS_COLORS = {
  [CERTIFICATE_STATUS.VALID]: 'success',
  [CERTIFICATE_STATUS.EXPIRED]: 'danger',
  [CERTIFICATE_STATUS.EXPIRING]: 'warning'
};